import React from 'react';
import {GridValidRowModel} from '@mui/x-data-grid-pro';
import {Box} from '@mui/system';
import {expenditureColumns, incomeColumns} from './IncomeExpenditureColumns';
import {StickyDataGrid} from '../../../components/Common/StickyDataGrid';
import {useHardFacts} from '../../../hooks/useHardFacts';
import {ErrorPage} from '../../../pages/ErrorPage';

export const IncomeExpenditureTable: React.FC = () => {
  const {data, error, loading} = useHardFacts();
  const incomeRows = data?.hardFacts?.incomes ?? [];
  const expenditureRows = data?.hardFacts?.expenditures ?? [];

  if (error) {
    return <ErrorPage text={error.message} />;
  }

  return (
    <>
      <StickyDataGrid
        sx={{
          overflowY: 'scroll',
          height: '250px',
        }}
        rowHeight={40}
        rows={incomeRows as readonly GridValidRowModel[]}
        columns={incomeColumns}
        hideFooter
        loading={loading}
      />
      <Box mt={2}>
        <StickyDataGrid
          sx={{
            overflowY: 'scroll',
            height: '250px',
          }}
          rowHeight={40}
          rows={expenditureRows as readonly GridValidRowModel[]}
          columns={expenditureColumns}
          hideFooter
          loading={loading}
        />
      </Box>
    </>
  );
};
